import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setDialog as setDialogConnect } from '../actions/navigation'
import { loadUserInfo as loadUserInfoConnect } from '../actions/account'

const DownloadCSV = ({ isLoggedIn, canDownloadFeedback, canDownloadErrors, loadUserInfo, setDialog }) => {
    useEffect(() => {
        loadUserInfo()
    }, [])
    const download = type => {
        const anchor = document.createElement('a')
        anchor.download = 'Test.csv'
        anchor.href = `/download-csv/${type}`
        anchor.click()
    }

    const noPermissions = !canDownloadFeedback && !canDownloadErrors

    return (
        <div>
            <header>
                <h2 className="title">Summative Feedback Reports</h2>
            </header>
            {isLoggedIn ? (
                <>
                    {canDownloadFeedback && (
                        <div>
                            <button type="button" className="button is-primary" onClick={() => download('feedback')}>
                                Download feedback
                            </button>
                            <br />
                            <br />
                        </div>
                    )}
                    {canDownloadErrors && (
                        <div>
                            <button type="button" className="button is-primary" onClick={() => download('errors')}>
                                Download reported errors
                            </button>
                        </div>
                    )}
                    {noPermissions && <p>You do not have permission to download feedback reports.</p>}
                </>
            ) : (
                <>
                    <p>Please sign in to view feedback reports.</p>
                    <button type="button" className="button is-primary" onClick={() => setDialog('signIn')}>
                        Sign in
                    </button>
                    <br />
                </>
            )}
            <br />
            <br />
            <Link to="..">To main page</Link>
        </div>
    )
}

DownloadCSV.propTypes = {
    // redux state
    isLoggedIn: PropTypes.bool.isRequired,
    canDownloadFeedback: PropTypes.bool.isRequired,
    canDownloadErrors: PropTypes.bool.isRequired,
    // redux action
    loadUserInfo: PropTypes.func.isRequired,
    setDialog: PropTypes.func.isRequired
}

export default connect(
    ({ account: { email, permissions } }) => ({
        isLoggedIn: !!email,
        canDownloadFeedback: permissions.canDownloadFeedback,
        canDownloadErrors: permissions.canDownloadErrors
    }),
    dispatch => ({
        loadUserInfo: () => dispatch(loadUserInfoConnect()),
        setDialog: modalName => dispatch(setDialogConnect(modalName))
    })
)(DownloadCSV)
